var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var gql = String.raw;
export var AllPeople = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  allPeople {\n    ...EntityListFields\n    linkedin threads twitter facebook\n    position\n    listPriority\n    organisation { \n      id name \n      location {\n        __typename id slug name\n        latitude longitude\n      }\n    }\n  }\n"], ["\n  allPeople {\n    ...EntityListFields\n    linkedin threads twitter facebook\n    position\n    listPriority\n    organisation { \n      id name \n      location {\n        __typename id slug name\n        latitude longitude\n      }\n    }\n  }\n"])));
var templateObject_1;